<template>
  <button :class="$style.questionBtn"
          @click="help">?</button>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Action } from 'vuex-class';
import { SHOW_HELP } from '@/apps/configurator/store/types';

/**
 * Configurator help button.
 */
@Component()
export default class ConfiguratorHelpButton extends Vue {
  @Action(SHOW_HELP) showHelp;

  /**
   * Help button action.
   */
  help() {
    this.showHelp();
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';
@import '@/style/helpers.scss';

.questionBtn {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 27px;
  height: 27px;
  border: 1px solid $green2;
  border-radius: 50%;
  color: $green2;
  outline: none;

  @media screen and (max-width: $kiosk-breakpoint-max) {
    right: 50px;
    bottom: 0;
    width: 50px;
    height: 50px;
    border-width: 2px;
    font-size: rem(32px);
  }

  @media screen and (max-width: $mobile-breakpoint-max) {
    top: 12px;
    right: 8px;
    width: 27px;
    height: 27px;
    border-width: 1px;
    font-size: rem(17px);
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/configurator/components/ConfiguratorHelpButton.vue